/* ---------- mini player ---------- */
.mini {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: calc(var(--nav-h) + var(--safe-b) + 6px);
  height: calc(var(--mini-h) - 8px);
  z-index: 49;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 6px 0 6px;
  border-radius: var(--r-md);
  background: rgb(28 28 31 / 0.985);
  backdrop-filter: blur(20px) saturate(1.3);
  border: 1px solid var(--border);
  box-shadow: 0 10px 30px rgb(0 0 0 / 0.5);
  overflow: hidden;
  animation: bb-fade-in var(--t-med) var(--ease);
}

.miniMain {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  height: 100%;
}

.miniText {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.miniTitle,
.miniSub {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.miniTitle {
  font-size: var(--fs-sm);
  font-weight: 700;
}

.miniSub {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.miniPlay {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  color: white;
}

.miniSpin {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2.5px solid rgb(255 255 255 / 0.2);
  border-top-color: white;
  animation: bb-spin 0.7s linear infinite;
}

.miniProgress {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 0;
  height: 2px;
  background: var(--accent);
  transform-origin: left;
  border-radius: 2px;
}

/* ---------- now playing ---------- */
.npRoot {
  position: fixed;
  inset: 0;
  z-index: 400;
  display: flex;
  justify-content: center;
  background: #000;
  animation: npIn var(--t-slow) var(--ease);
}

@keyframes npIn {
  from {
    transform: translateY(100%);
  }
}

.npBackdrop {
  position: absolute;
  inset: -40px;
  background: radial-gradient(ellipse at top, rgb(var(--accent-rgb) / 0.2), #000 70%);
  background-size: cover;
  background-position: center;
  filter: blur(60px) saturate(1.4) brightness(0.45);
  transform: scale(1.2);
}

.np {
  position: relative;
  width: min(100%, var(--app-max));
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: calc(var(--safe-t) + 8px) 24px calc(var(--safe-b) + 20px);
  transition: transform var(--t-fast);
}

.npHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 -12px;
}

.npContext {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}

.npContext small {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--text-3);
  font-weight: 700;
}

.npContext span {
  font-size: var(--fs-sm);
  font-weight: 700;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.npArt {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  touch-action: none;
}

.npArtInner {
  width: min(100%, 46dvh);
  aspect-ratio: 1;
  box-shadow: 0 30px 80px rgb(0 0 0 / 0.6);
  border-radius: 22px;
  transform: scale(0.9);
  transition: transform var(--t-slow) var(--ease-spring);
}

.npArtPlaying {
  transform: scale(1);
}

.npInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.npTitles {
  min-width: 0;
}

.npTitles h2 {
  font-size: var(--fs-xl);
  font-weight: 800;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.npTitles button {
  color: var(--text-2);
  font-size: var(--fs-md);
  font-weight: 600;
  margin-top: 2px;
}

.npTitles button:hover {
  color: var(--text);
  text-decoration: underline;
}

.npPreview {
  margin-top: 10px;
  font-size: var(--fs-xs);
  color: var(--warning);
}

.npError {
  margin-top: 8px;
  font-size: var(--fs-xs);
  color: var(--danger);
  text-align: center;
}

.scrubber {
  margin-top: 20px;
  padding: 10px 0;
  cursor: pointer;
  touch-action: none;
}

.scrubTrack {
  position: relative;
  height: 4px;
  border-radius: 4px;
  background: rgb(255 255 255 / 0.18);
}

.scrubFill {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 4px;
  background: white;
}

.scrubThumb {
  position: absolute;
  top: 50%;
  width: 14px;
  height: 14px;
  margin: -7px 0 0 -7px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 8px rgb(0 0 0 / 0.4);
  transition: transform var(--t-fast);
}

.scrubber:active .scrubThumb {
  transform: scale(1.3);
}

.times {
  display: flex;
  justify-content: space-between;
  font-size: var(--fs-xs);
  color: var(--text-3);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.transport {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px -8px 0;
}

.bigPlay {
  display: grid;
  place-items: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: white;
  color: #000;
  transition: transform var(--t-fast) var(--ease-spring);
}

.bigPlay:active {
  transform: scale(0.92);
}

.repeatBtn {
  position: relative;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  color: var(--text);
}

.repeatOn {
  color: var(--accent);
}

.repeatBtn span {
  position: absolute;
  top: 6px;
  right: 4px;
  font-size: 9px;
  font-weight: 800;
  background: var(--accent);
  color: var(--accent-ink);
  border-radius: 50%;
  width: 12px;
  height: 12px;
  display: grid;
  place-items: center;
}

.npFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 20px -8px 0;
}

.volume {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-3);
}

.volume input {
  flex: 1;
  accent-color: white;
}

/* ---------- queue ---------- */
.queue {
  padding: 0 12px 24px;
}

.queue h3 {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: var(--fs-md);
  font-weight: 800;
  margin: 16px 8px 8px;
}

.queue h3 small {
  font-size: var(--fs-xs);
  color: var(--text-3);
  font-weight: 600;
}

.queueEmpty {
  padding: 8px;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.queueItem {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: var(--r-md);
}

.queueItem:hover {
  background: var(--surface-2);
}

.queueCurrent strong {
  color: var(--accent);
}

.queueMain {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  text-align: left;
}

.queueMain span {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.queueMain strong,
.queueMain small {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.queueMain strong {
  font-size: var(--fs-sm);
}

.queueMain small {
  color: var(--text-3);
  font-size: var(--fs-xs);
}
